

import Accounts from "./Accounts";


class Marketing extends Accounts{
    constructor(params) {
      super(params);
    
     this.accountLabel = "Marketing";
    this.accountType = "Marketing";
    this.account = "marketing";
    this.isParent = true; 
  this.setParameters(params);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }
      setConnectionId(val){
      this.connectionId = val;
    }
}

export default Marketing;
  